import { images } from "../assets/img";

export const NAIL_SHOP_INFO = {
  ggMapUrl: "https://maps.app.goo.gl/rWkdVx9psne3Znz8A",
  address: "75 Bread St, Edinburgh EH3 9AH, United Kingdom",
  ggMapIframeUrl:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1117.0996915915919!2d-3.203031400341308!3d55.94591608960471!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4887c7f8de64139d%3A0xc841f63b036e0522!2sBlue%20Pearl%20Nails!5e0!3m2!1sen!2s!4v1756459421222!5m2!1sen!2s",
  email: "UPDATE LATER",
  tel: "+447405830779",
  phone: "+44 740 583 0779",
  facebookId:"102765367795796",
  instagramName: "blue_pearl_nails_edinburgh",
  tiktok: "https://tiktok.com/@blue.pearl.nails",
  name: "Blue Pearl Nails",
  bookingUrl: "https://bluepearlnails.setmore.com",
  openingTime:{
    openTime:{weekdays: "MONDAY - SATURDAY", time:"09:30 - 18:30"},
    closeTime:{weekdays: "SUNDAY", time:"CLOSED"}
  }
};

NAIL_SHOP_INFO.instagram = `https://www.instagram.com/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.instagramChatUrl = `https://ig.me/m/${NAIL_SHOP_INFO.instagramName}`;
NAIL_SHOP_INFO.facebook = `https://www.facebook.com/profile.php?id=${NAIL_SHOP_INFO.facebookId}`
NAIL_SHOP_INFO.facebookMessengerUrl = `http://m.me/${NAIL_SHOP_INFO.facebookId}`

export const SOLCO_INFO = {
  facebook: "https://www.facebook.com/solcoagency.marketing",
  website: "https://solcomarketing.com",

  huaCatLuongWebsite: "https://huacatluong.com",
};

export const LANGUAGE_ID = {
  vi: "vi",
  en: "en",
};

export const CUSTOMER_FEEDBACK = [
  {
    name: "Chloe Anderson",
    feedback:
      "Ã¢â‚¬Å“The calm atmosphere here is amazing. From the moment I walked in, I felt completely at ease. My nails look perfect every single time, and the team always goes the extra mile to make sure IÃ¢â‚¬â„¢m happy. TheyÃ¢â‚¬â„¢re so kind and professional, and I always leave not just with beautiful nails, but also feeling refreshed and cared for.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/g7mJPq8.png",
  },
  {
    name: "Emily Carter",
    feedback:
      "Ã¢â‚¬Å“This salon is absolutely beautiful and always spotless. There are so many gorgeous colors to choose from that itÃ¢â‚¬â„¢s almost impossible to decide, but the staff are so patient and helpful. They really take their time to make sure everything is done perfectly, and the end result always exceeds my expectations. Definitely my favorite spot in town for a bit of self-care.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/VxekuRS.png",
  },
  {
    name: "Sophia Bennett",
    feedback:
      "Ã¢â‚¬Å“I booked a last-minute manicure here, and IÃ¢â‚¬â„¢m so glad I did. The whole process felt effortless and relaxing, and the finish on my nails is absolutely flawless. What really impressed me is how long itÃ¢â‚¬â„¢s lasted compared to other places IÃ¢â‚¬â„¢ve tried Ã¢â‚¬â€ I didnÃ¢â‚¬â„¢t have to worry about chips or fading. IÃ¢â‚¬â„¢ll definitely be coming back again and again.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/0JaNnhK.png",
  },
  {
    name: "Olivia Green",
    feedback:
      "Ã¢â‚¬Å“I had both a manicure and pedicure here, and each time was such a wonderful experience. The staff are so friendly and attentive, and the salon itself is incredibly clean and inviting. The results are amazing Ã¢â‚¬â€ my nails look gorgeous and my feet feel so soft. I always look forward to my next visit because I know IÃ¢â‚¬â„¢ll leave feeling pampered.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/aCEUi1W.png",
  },
  {
    name: "Amelia Hughes",
    feedback:
      "Ã¢â‚¬Å“I walked in without an appointment and was pleasantly surprised to be seen right away. The whole atmosphere was warm and welcoming, and the team made me feel completely comfortable. The gel nails I had done are honestly the best IÃ¢â‚¬â„¢ve ever had Ã¢â‚¬â€ shiny, strong, and beautifully done. ItÃ¢â‚¬â„¢s rare to find a place that combines such great service with such skill. Highly recommend!Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/F7M14q2.png",
  },
  {
    name: "Grace Mitchell",
    feedback:
      "Ã¢â‚¬Å“This is such a lovely clean salon with an incredibly relaxing vibe. The attention to detail was fantastic, and my acrylic nails turned out beautifully. The pedicure chairs are so comfortable that I nearly fell asleep! ItÃ¢â‚¬â„¢s more than just a nail appointment here Ã¢â‚¬â€ it feels like a little escape where I can recharge and leave looking and feeling better than ever.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/KxhUFKM.jpg",
  },
  {
    name: "Hannah Ward",
    feedback:
      "Ã¢â‚¬Å“I brought my sister here as a treat, and we both loved every moment of it. From the warm welcome to the attentive care throughout, the team made us feel special. We chatted, laughed, and left with nails that looked absolutely amazing. It was such a lovely experience to share, and now weÃ¢â‚¬â„¢ve both decided this will be our regular spot for pampering.Ã¢â‚¬Â",
    avatar: "https://i.imgur.com/kI3rsKc.jpg",
  },
]


export const MENU_HEADER = [
  { name: "Home", navigationKey: "home" },
  { name: "About Us", navigationKey: "about-us" },
  { name: "Services", navigationKey: "services" },
  { name: "Booking", navigationKey: NAIL_SHOP_INFO.bookingUrl },
  // { name: "Contacts", navigationKey: "contactsRef" },
  { name: "Contact", navigationKey: "contact-us" },
  { name: "Policy", navigationKey: "policy" },
];
